import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Menu } from '@/elements';
import { TESTING_CLIENT_IDS } from '@/config/constants';
import { IMPORT_CLIENT_IDS } from '@/config/constants';
import { ADMIN_CLIENT_IDS } from '@/config/constants';
import { REAL_TIME_CLIENT_IDS } from '@/config/constants';
import { FACE_CLIENT_IDS } from '@/config/constants';
import { LIVE_EVACUATION_CLIENT_IDS } from '@/config/constants';
import { withClientId } from 'hocs';

import { createStructuredSelector } from 'reselect';
import { userSelector, operatorTabDetailsSelector, operatorTabDetailsStatusSelector } from 'redux/selectors'
import {  getOperatorTab } from 'redux/modules/model/operator'

import './index.scss';

class TopNavigation extends Component {

	componentDidMount() {
		const { clientId, user, getOperatorTab } = this.props;
		const operator = user && user.currentUser && user.currentUser.operator
		getOperatorTab({ clientId, username: operator.username });
	}

	render() {
		const {
			clientId,
			onMenuClick,
			selectedKeys,
			verticalConfig,
			operatorTab
		} = this.props;
		let directoryEnabled = true
		let liveViewEnabled = true
		let operatorsEnabled = true
		let reportsEnabled = true
		let notificationsEnabled = true
		let faceEnabled = true
		let realTimeEnabled = true
		liveViewEnabled = get(
			verticalConfig,
			'core.liveViewEnabled',
			false,
		);

		const attendanceEnabled = Boolean(
			get(verticalConfig, 'attendance', false),
		);

		const evacDemoEnabled = TESTING_CLIENT_IDS.includes(clientId);
		const importEnabled = IMPORT_CLIENT_IDS.includes(clientId);
		const adminEnabled = ADMIN_CLIENT_IDS.includes(clientId);
		const liveEvacuationEnabled = LIVE_EVACUATION_CLIENT_IDS.includes(clientId);
		realTimeEnabled = REAL_TIME_CLIENT_IDS.includes(clientId);
		faceEnabled = FACE_CLIENT_IDS.includes(clientId);
		// Don't show tabs according to the tabs in the operator tab table
		// (Tabs inserted for the user in the operator table name won't appear in the frontend)
		if(operatorTab){
			operatorTab.forEach(operator => {
				if(operator.tabId === "directory"){
					directoryEnabled = false
				} else if(operator.tabId === "live-view"){
					liveViewEnabled = false
				} else if(operator.tabId === "operators"){
					operatorsEnabled = false
				} else if(operator.tabId === "reports"){
					reportsEnabled = false
				} else if(operator.tabId === "notifications"){
					notificationsEnabled = false
				} else if(operator.tabId === "face"){
					faceEnabled = false
				} else if(operator.tabId === "real-time"){
					realTimeEnabled = false
				}
			})
		}

		return (
			<Menu
				className="top-navigation"
				onClick={onMenuClick}
				selectedKeys={selectedKeys}
				mode="horizontal"
				theme="dark"
			>
				{directoryEnabled && (
					<Menu.Item key="/directory">Directory</Menu.Item>
				)}
				{liveViewEnabled && (
					<Menu.Item key="/live-view">Live View</Menu.Item>
				)}
				{liveEvacuationEnabled && (
					<Menu.Item key="/live-evacuation">Live Evacuation</Menu.Item>
				)}

				{faceEnabled && (
					<Menu.Item key="/face-live-view">Face Live View</Menu.Item>
				)}

				{realTimeEnabled && (
					<Menu.Item key="/realtime-view">Real Time View</Menu.Item>
				)}

				{/*faceEnabled && (
					<Menu.Item key="/face-visits">Face Visits</Menu.Item>
				)*/}

				{attendanceEnabled && (
					<Menu.Item key="/attendance">Attendance</Menu.Item>
				)}
				{operatorsEnabled && (
					<Menu.Item key="/operators">Operators</Menu.Item>
				)}
				{!adminEnabled && reportsEnabled && (
					<Menu.Item key="/reports">Reports</Menu.Item>
				)}

				{/*<Menu.Item key="/">*/}
				{/*Sitemap*/}
				{/*</Menu.Item>*/}

				{/*<Menu.Item key="/navigation">*/}
				{/*Navigation*/}
				{/*</Menu.Item>*/}

				{/*<Menu.Item key="/site-manager">*/}
				{/*Site manager*/}
				{/*</Menu.Item>*/}

				{/*<Menu.Item key="/evacuation">*/}
				{/*Evacuation*/}
				{/*</Menu.Item>*/}

				{/*{evacDemoEnabled && <Menu.Item key="/evacuation-demo">*/}
				{/*Evacuation*/}
				{/*</Menu.Item>}*/}

				{evacDemoEnabled && (
					<Menu.Item key="/evacuation">Evacuation</Menu.Item>
				)}
				{!adminEnabled && notificationsEnabled && (
					<Menu.Item key="/notifications">Notifications</Menu.Item>
				)}

				{adminEnabled && (
					<Menu.Item key="/client">Client</Menu.Item>
				)}
				{adminEnabled && (
					<Menu.Item key="/clientconfig">Client Config</Menu.Item>
				)}
				{/* {adminEnabled && (
					<Menu.Item key="/site-manager">Site</Menu.Item>
				)} */}
				{adminEnabled && (
					<Menu.Item key="/site">Site</Menu.Item>
				)}
				{adminEnabled && (
					<Menu.Item key="/agent">Agent</Menu.Item>
				)}
				{/* {adminEnabled && (
					<Menu.Item key="/zone">Zone</Menu.Item>
				)}
				{adminEnabled && (
					<Menu.Item key="/reader">Reader</Menu.Item>
				)} */}
				{/* {adminEnabled && (
					<Menu.Item key="/antenna">Antenna</Menu.Item>
				)}
				{adminEnabled && (
					<Menu.Item key="/camera">Camera</Menu.Item>
				)} */}
				{/* {adminEnabled && (
					<Menu.Item key="/profile">Profile</Menu.Item>
				)} */}
				{adminEnabled && (
					<Menu theme="dark">
						<Menu.Item key="/zone">Zone</Menu.Item>
						<Menu.Item key="/reader">Reader</Menu.Item>
						<Menu.Item key="/antenna">Antenna</Menu.Item>
						<Menu.Item key="/camera">Camera</Menu.Item>
					<Menu.Item key="/detectable">Detectable</Menu.Item>
					<Menu.Item key="/summary">Summary</Menu.Item>
					</Menu>
				)}

				{/* {adminEnabled && (
					<Menu.Item key="/summary">Summary</Menu.Item>
				)} */}

				{importEnabled && (
					<Menu.Item key="/imports">Imports</Menu.Item>
				)}
			</Menu>
		);
	}
}

export const selector = createStructuredSelector({
	verticalConfig: ({ user: { currentUser } }) => currentUser.verticalConfig,
	user: userSelector,
	operatorTab: operatorTabDetailsSelector,
  	operatorTabDetailsStatus: operatorTabDetailsStatusSelector
});

export const mapDispatchToProps = dispatch => ({
	listHolders: params => dispatch(listHolders(params)),
	getOperatorTab: params => dispatch(getOperatorTab(params))
});

export default compose(
	withClientId,
	connect(selector, mapDispatchToProps),
)(TopNavigation);



// WEBPACK FOOTER //
// ./src/components/top-navigation/index.js